export default __webpack_public_path__ + "static/media/intermedIcon.4e99a7b9.svg";